const LEVEL_ICONS: Readonly<Record<number, string>> = {
  1: 'south_america',
  2: 'hive',
  3: 'workspaces',
  4: 'church-group',
  5: 'church',
};

const LEVEL_NAME_ICONS: Readonly<Record<string, string>> = {
  iglesiaregional: 'south_america',
  areaapostol: 'hive',
  areadeapostol: 'hive',
  apostlearea: 'hive',
  distrito: 'workspaces',
  grupo: 'church-group',
  grupocomunidad: 'church-group',
  grupodecomunidad: 'church-group',
  grupodecomunidades: 'church-group',
  comunidad: 'church',
};

export function getOrganizationUnitIcon(levelId?: number | null, levelName = ''): string {
  const normalizedName = levelName.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s/g, '').toLowerCase();
  return LEVEL_ICONS[levelId ?? 0] ?? LEVEL_NAME_ICONS[normalizedName] ?? 'domain';
}
